import { Registry } from "./registry.js";
export function registerComponent(key, Class, options){ Registry.registerComponent(key, Class, options); }